import MicrosoftIcon from "@/components/ui/OpticksIcons/MicrosoftIcon";
import { routesMap } from "@/components/routes/routes";
import ChannelIntegrationGuide from "@/components/channel-integration-guide/ChannelIntegrationGuide";
import type { ChannelIntegrationConfig } from "@/components/channel-integration-guide/ChannelIntegrationGuide.types";
import MicrosoftIntegrationStep2 from "./steps/components/MicrosoftIntegrationStep2";
import MicrosoftIntegrationStep3 from "./steps/components/MicrosoftIntegrationStep3";
import MicrosoftIntegrationStep1 from "./steps/components/MicrosoftIntegrationStep1";

const microsoftConfig: ChannelIntegrationConfig = {
  channelName: "Microsoft Ads",
  channelDisplayName: "Microsoft",
  platformKey: "microsoft",
  oauthPlatformKey: "microsoft",
  icon: <MicrosoftIcon size={32} />,
  supportsOAuth: false,
  overviewPath: routesMap.integration.microsoft.overview.path,
  linkingPath: routesMap.integration.microsoft.linking.path,
  pixelManagementPath:
    routesMap.integration.channelsCenter.path + "?channel=microsoft",
  guideSteps: [
    {
      content: (stepLabel) => (
        <MicrosoftIntegrationStep1 stepLabel={stepLabel} />
      ),
    },
    {
      content: (stepLabel) => (
        <MicrosoftIntegrationStep2 stepLabel={stepLabel} />
      ),
    },
    {
      content: (stepLabel) => (
        <MicrosoftIntegrationStep3 stepLabel={stepLabel} />
      ),
    },
  ],
};

const MicrosoftIntegration = () => {
  return <ChannelIntegrationGuide config={microsoftConfig} />;
};

export default MicrosoftIntegration;
